module.exports = __webpack_public_path__ + "static/img/2.58f4456f.png";